import React, { Component } from "react"
import { connect } from "react-redux"
import lodash from "lodash"

import DialogTitle from "@material-ui/core/DialogTitle"
import Dialog from "@material-ui/core/Dialog"
import DialogContent from "@material-ui/core/DialogContent"
import { memberConstants } from "../../constants"
import Grid from "@material-ui/core/Grid"
import IconButton from "@material-ui/core/IconButton"
import CloseIcon from "@material-ui/icons/Close"
import Typography from "@material-ui/core/Typography"
import Divider from "@material-ui/core/Divider"

const style = {
  closeButton: {
    position: "absolute",
    top: 0,
    right: 0,
  },
}

class MemberUserAgentDetail extends Component {
  closeDialog() {
    const { dispatch } = this.props
    dispatch({ type: memberConstants.CLOSE_MEMBER_USER_AGENT_DETAIL })
  }

  render() {
    const { userAgentDetail } = this.props
    const {
      isOpen,
      registerChannel,
      registerUserAgent,
      lastLoginUserAgent,
      lastLoginChannel,
    } = userAgentDetail
    return (
      <Dialog
        onClose={() => {
          this.closeDialog()
        }}
        aria-labelledby="simple-dialog-title"
        open={isOpen}
      >
        <DialogTitle>
          <IconButton
            aria-label="close"
            style={style.closeButton}
            onClick={() => {
              this.closeDialog()
            }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent>
          {!lodash.isEmpty(registerUserAgent) && (
            <>
              <Grid container style={{minWidth: 512}} spacing={0}>
                <Grid item xs={12} md={12}>
                  <Typography variant="h6" gutterBottom>
                    Register
                  </Typography>
                </Grid>
                <Grid item xs={12} md={2}>
                  <Typography variant="body1" gutterBottom>
                    Device :
                  </Typography>
                </Grid>
                <Grid item xs={12} md={10}>
                  <Typography variant="body1" gutterBottom>
                    {registerUserAgent.source}
                  </Typography>
                </Grid>
                <Grid item xs={2} md={2}>
                  <Typography variant="body1" gutterBottom>
                    Channel :
                  </Typography>
                </Grid>
                <Grid item xs={10} md={10}>
                  <Typography variant="body1" gutterBottom>
                    {registerChannel}
                  </Typography>
                </Grid>
              </Grid>
              <br />
              <Divider />
              <br />
            </>
          )}
          {!lodash.isEmpty(lastLoginUserAgent) && (
            <>
              <Grid container style={{minWidth: 512}} spacing={0}>
                <Grid item xs={12} md={12}>
                  <Typography variant="h6" gutterBottom>
                    Last Login
                  </Typography>
                </Grid>
                <Grid item xs={12} md={2}>
                  <Typography variant="body1" gutterBottom>
                    Device :
                  </Typography>
                </Grid>
                <Grid item xs={12} md={10}>
                  <Typography variant="body1" gutterBottom>
                    {lastLoginUserAgent.source}
                  </Typography>
                </Grid>
                <Grid item xs={2} md={2}>
                  <Typography variant="body1" gutterBottom>
                    Channel :
                  </Typography>
                </Grid>
                <Grid item xs={10} md={10}>
                  <Typography variant="body1" gutterBottom>
                    {lastLoginChannel}
                  </Typography>
                </Grid>
              </Grid>
            </>
          )}
        </DialogContent>
      </Dialog>
    )
  }
}

function mapStateToProps(state) {
  const { userAgentDetail } = state.member
  return {
    userAgentDetail,
  }
}
const connectedComponent = connect(mapStateToProps)(MemberUserAgentDetail)

export default connectedComponent
